import React, { Fragment, useState, useEffect } from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilePdf, faFileExcel } from "@fortawesome/free-solid-svg-icons";
import 'moment-timezone';
import ExcelReportFees from '../../Fees/components/ExcelReportFees';
import ReportFeeExpensePDF from '../../Fees/components/ReportFeeExpensePDF';

const DoctorFeesTableActions = ({ data }) => {

    useEffect(() => {

    }, []);

    const loadFeeInfo = async (infoExport, idFeeExpense) => {
        await fetch(process.env.REACT_APP_PUBLIC_URL + `honorarios-efectuados/${idFeeExpense}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        }).then(response => {
            if (response.status != 500 && response.status != 403) {
                return response.json();
            }
            else {
                throw new Error('Ha ocurrido un error consultando el Honorario');
            }
        }).then(dataResponse => {
            let dataHonorario = dataResponse.honorario;
            dataHonorario.honorarios_profesional = dataHonorario.honorarios_profesional.honorariosMedicos;

            let clinicaData = JSON.parse(sessionStorage.getItem('clinica'));
            let localidadData = JSON.parse(sessionStorage.getItem('localidad'));

            clinicaData.nombre_ciudad = localidadData.ciudad;
            clinicaData.nombre_departamento = localidadData.dpto;

            switch (infoExport) {
                case "EXCEL":
                    ExcelReportFees.exportExcel([dataHonorario]);
                    break;
                case "PDF":
                    ReportFeeExpensePDF(dataHonorario, clinicaData);
                    break;
                default:
                    alert("Opción no Disponible");
                    break;
            }
        }).catch((error) => {
            console.error('Error:', error);
        });
    }

    return (<Fragment>
        <td role="cell">
            <Tooltip title="Exportar a PDF">
                <IconButton style={{ fontSize: '20px' }} onClick={() => {
                    loadFeeInfo("PDF",data.data.original.id_honorario_efectuado);
                }}>
                    <FontAwesomeIcon icon={faFilePdf} />
                </IconButton>
            </Tooltip>
            <Tooltip title="Exportar a Excel">
                <IconButton style={{ fontSize: '20px' }} onClick={() => {
                    loadFeeInfo("EXCEL",data.data.original.id_honorario_efectuado);
                }}>
                    <FontAwesomeIcon icon={faFileExcel} />
                </IconButton>
            </Tooltip>
        </td>

    </Fragment>)
}

export default DoctorFeesTableActions;